(() => {
  if (!customElements.get("sale-product")) {
    class SaleProduct extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {

        if (typeof Swiper === 'undefined') {
          console.error("Swiper is not loaded.");
          return;
        }

        this.swiperEl = this.querySelector("[data-sale-product-swiper]");
        if (!this.swiperEl) return;

        this.swiper = new Swiper(this.swiperEl, {
          slidesPerView: 1,
          spaceBetween: 40,
          loop: true,
          pagination: {
            el: ".swiper-pagination",
            type: "progressbar"
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
          }
        });

        const nextArrow = this.querySelector('.swiper-button-next');
        const prevArrow = this.querySelector('.swiper-button-prev');

        [nextArrow, prevArrow].forEach(arrow => {
          if (arrow) {
            arrow.addEventListener('click', (e) => {
              e.stopPropagation();
            });
          }
        });

        this.startAllCountdowns();

        if (Shopify.designMode) {
          document.addEventListener("shopify:section:load", () => {
            this.swiper.update();
            this.startAllCountdowns(); // Reinitialize countdowns in editor
          });
        }
      }

      startAllCountdowns() {
        const countdownEls = this.querySelectorAll('.deal-ends_countdown');
        if (!countdownEls.length) return;

        countdownEls.forEach((el) => {
          const endTimeStr = el.getAttribute('data-deal-end');
          const countdownText = el.querySelector('.countdown-text');

          if (!endTimeStr || !countdownText) return;

          const endTime = new Date(endTimeStr).getTime();

          const updateCountdown = () => {
            const now = new Date().getTime();
            const distance = endTime - now;

            if (distance <= 0) {
              countdownText.textContent = "Expired";
              clearInterval(this.timer);
              return;
            }

            const totalHours = Math.floor(distance / (1000 * 60 * 60));
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);

            countdownText.textContent =
              `${String(totalHours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
          };

          updateCountdown(); // Initial render
          this.timer = setInterval(updateCountdown, 1000);
        });
      }
    }

    customElements.define("sale-product", SaleProduct);
  }
})();
